import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
var dragHelperStyles = require('../components/MailListDragHelper.scss');
export function getMailListRowDragPreview(dragData) {
    var mailListRowDragData = dragData;
    var count = mailListRowDragData.rowKeys.length;
    var stringToShow = count <= 1 ? strings.conversation : strings.conversations;
    switch (mailListRowDragData.tableListViewType) {
        case 0 /* Conversation */:
            stringToShow = count <= 1 ? strings.conversation : strings.conversations;
            break;
        case 1 /* Message */:
            stringToShow = count <= 1 ? strings.item : strings.items;
            break;
    }
    var innerText = format('{0} {1}', count, stringToShow);
    var elem = document.createElement('div');
    elem.className = dragHelperStyles.dragHelperStyle;
    elem.innerText = innerText;
    return elem;
}
export function getMailListItemPartDragPreview(dragData) {
    var mailListItemPartDragData = dragData;
    var count = mailListItemPartDragData.itemIds.length;
    var stringToShow = count <= 1 ? strings.item : strings.items;
    var innerText = format('{0} {1}', count, stringToShow);
    var elem = document.createElement('div');
    elem.className = dragHelperStyles.dragHelperStyle;
    elem.innerText = innerText;
    return elem;
}
export var MAIL_ITEM_DRAG_XOFFSET = -12;
export var MAIL_ITEM_DRAG_YOFFSET = 5;
//# sourceMappingURL=mailListDragUtil.js.map